var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"help d-flex flex-column"},[_c('page-title',{staticClass:"mb-4",attrs:{"title":_vm.$t('help'),"sub-title":_vm.$t('help_sub_title')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }